import * as yup from 'yup';

export const provisionalReceiptValidations = yup.object().shape({
  ncmCode: yup
    .string()
    .nullable()
    .test(function(value) {
      if(+this.parent.taxSettings == 0 || !!value) {
        return true;
      }

      if(!this.parent.cfopCode && !this.parent.icmsOriginId && !this.parent.icmsCst) {
        return true;
      }

      return this.createError({
        message: 'O NCM é obrigatório',
        path: 'ncmCode'
      });
    }),
  cfopCode: yup
    .string()
    .nullable()
    .test(function(value) {
      if(value?.toString()?.length < 4) {
        return this.createError({
          message: 'O tamanho mínimo do código CFOP é de 4 caracteres',
          path: 'cfopCode'
        });
      }

      if(+this.parent.taxSettings == 0 || !!value) {
        return true;
      }

      if(!this.parent.ncmCode && !this.parent.icmsOriginId && !this.parent.icmsCst) {
        return true;
      }

      return this.createError({
        message: 'O código CFOP é obrigatório',
        path: 'cfopCode'
      });
    }),
  icmsOriginId: yup
    .string()
    .nullable()
    .test(function(value) {
      if(+this.parent.taxSettings == 0 || !!value) {
        return true;
      }

      if(!this.parent.ncmCode && !this.parent.cfopCode && !this.parent.icmsCst) {
        return true;
      }

      return this.createError({
        message: 'A origem do ICMS é obrigatória',
        path: 'icmsOriginId'
      });
    }),
  icmsCst: yup
    .string()
    .nullable()
    .test(function(value) {
      if(+this.parent.taxSettings == 0 || !!value) {
        return true;
      }

      if(!this.parent.ncmCode && !this.parent.cfopCode && !this.parent.icmsOriginId) {
        return true;
      }

      return this.createError({
        message: 'A CST do ICMS é obrigatória',
        path: 'icmsCst'
      });
    })
});